
import { defineComponent } from 'vue';
import getAbout from '@/sanity/requests/about';
import LayoutCenter from '@/components/LayoutCenter.vue';
import { setMeta } from '@/store';

export default defineComponent({
  name: 'About',
  components: {
    LayoutCenter,
  },
  setup() {
    setMeta({ title: 'About' });
    return { ...getAbout() };
  },
});
